/**
 * @generated SignedSource<<5de97e8d2d429167344dff10058cedfa>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VideoPageEventData$data = {
  readonly __typename: "AuthorizedEvent";
  readonly canWrite: boolean;
  readonly created: string;
  readonly creators: ReadonlyArray<string>;
  readonly description: string | null | undefined;
  readonly hasPassword: boolean;
  readonly id: string;
  readonly isLive: boolean;
  readonly metadata: Record<string, Record<string, string[]>>;
  readonly opencastId: string;
  readonly series: {
    readonly id: string;
    readonly opencastId: string;
    readonly title: string;
    readonly " $fragmentSpreads": FragmentRefs<"SeriesBlockSeriesData">;
  } | null | undefined;
  readonly syncedData: {
    readonly duration: number;
    readonly endTime: string | null | undefined;
    readonly startTime: string | null | undefined;
    readonly thumbnail: string | null | undefined;
    readonly updated: string;
  } | null | undefined;
  readonly title: string;
  readonly " $fragmentSpreads": FragmentRefs<"VideoPageAuthorizedData">;
  readonly " $fragmentType": "VideoPageEventData";
} | {
  readonly __typename: "NotAllowed";
  readonly __typename: "NotAllowed";
  readonly " $fragmentType": "VideoPageEventData";
} | {
  // This will never be '%other', but we need some
  // value in case none of the concrete values match.
  readonly __typename: "%other";
  readonly " $fragmentType": "VideoPageEventData";
};
export type VideoPageEventData$key = {
  readonly " $data"?: VideoPageEventData$data;
  readonly " $fragmentSpreads": FragmentRefs<"VideoPageEventData">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "opencastId",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "eventPassword"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "eventUser"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "VideoPageEventData",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "description",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "creators",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "created",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isLive",
          "storageKey": null
        },
        (v2/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "metadata",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canWrite",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "hasPassword",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SyncedEventData",
          "kind": "LinkedField",
          "name": "syncedData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "updated",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "duration",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "startTime",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endTime",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "thumbnail",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": [
            {
              "kind": "Variable",
              "name": "eventPassword",
              "variableName": "eventPassword"
            },
            {
              "kind": "Variable",
              "name": "eventUser",
              "variableName": "eventUser"
            }
          ],
          "kind": "FragmentSpread",
          "name": "VideoPageAuthorizedData"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Series",
          "kind": "LinkedField",
          "name": "series",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v2/*: any*/),
            (v1/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "SeriesBlockSeriesData"
            }
          ],
          "storageKey": null
        }
      ],
      "type": "AuthorizedEvent",
      "abstractKey": null
    }
  ],
  "type": "Event",
  "abstractKey": "__isEvent"
};
})();

(node as any).hash = "efaac9cc11d6d92a1784c94f7d0a0356";

export default node;
